import React from "react";
import { useLocation } from "react-router-dom";
import DealersHeader from "../header/DealersHeader";
import FooterComponent from "../footer/footerComponent";
import DealersFooter from "../header/DealersFooter";
import DealerPortalDrawer from "./DealerPortalDrawer";
import ScrollToTopButton from "../../common/ScrollToTopButton/scrollToTopButton";
import HomeHeader from "../header/HomeHeader";
import HomeFooter from "../header/HomeFooter";
import { NZHeader } from "../header/NZHeader/NZHeader";
import FooterNZComponent from "../footer/footerNZComponent";
import DealerPortalRedirection from "./DealerPortalRedirection";
import { useRegion } from "../../context/RegionContext";

const Layout = ({ children }) => {
  const location = useLocation();
  const { region } = useRegion();

  const isDealersPortal = location.pathname.includes("/dealers-portal");
  const isVehiclePartsLookupPortal =
    location.pathname.includes("/dealers-portal/vehicle-parts-lookup") ||
    location.pathname.includes("/dealers-portal/inventory-list") ||
    location.pathname.includes("/shopping-cart");

  return (
    <div>
      {isVehiclePartsLookupPortal ? (
        <div className="p-[30px] flex">
          <div className="hidden md:block">
            <DealerPortalDrawer />
          </div>
          <main className="w-full">{children}</main>
        </div>
      ) : (
        <>
          {isDealersPortal ? (
            <DealersHeader />
          ) : region === "nz" ? (
            <>
              <DealerPortalRedirection />
              <NZHeader />
            </>
          ) : (
            <HomeHeader />
          )}
          <main>{children}</main>
          {isDealersPortal ? (
            <DealersFooter />
          ) : region === "nz" ? (
            <FooterNZComponent />
          ) : (
            <HomeFooter />
          )}
        </>
      )}

      <ScrollToTopButton />
    </div>
  );
};

export default Layout;
